SignaturePad = require('signature_pad')

define [], () ->
  (RentappService, $state, $uibModal, $timeout, $rootScope) ->
    restrict: "E"
    template: require("./signature.jade")
    scope: { field: "=", mode: "@", stage: "="}
    link: (scope, element, attrs) ->
      scope.signature_pad = null
      canvas = element.find('canvas')[0]
      
      if scope.mode == "view"
        scope.signature_pad = new SignaturePad(canvas)
        if scope.field.value
          scope.signature_pad.fromData(JSON.parse(scope.field.value))
        scope.signature_pad.off()
      else
        scope.signature_pad = new SignaturePad(canvas, {
          onEnd: () ->
            scope.field.value = JSON.stringify(scope.signature_pad.toData())
        })

        if scope.field.value 
          scope.signature_pad.fromData(JSON.parse(scope.field.value))
      
      $rootScope.$on('signature-clear', (event, data) ->
        if scope.field.name == data.name
          scope.field.value = null
          scope.signature_pad.clear()
      )

      $rootScope.$on('signature-updated', (event, data) ->
        if scope.field.name == data.name
          scope.signature_pad.fromData(JSON.parse(scope.field.value))
      )




// WEBPACK FOOTER //
// ./directives/freeforms/newSignature/signature.coffee